import { gql, useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";

const DUPLICATE_PRICE_LIST = gql`
  mutation ($sourcePriceListId: ID!, $name: String!) {
    duplicatePriceList(sourcePriceListId: $sourcePriceListId, name: $name) {
      priceList {
        id
      }
    }
  }
`;

const DuplicatePriceListView = ({
  sourcePriceListId,
  initialName = "",
  complete,
}) => {
  const [name, setName] = useState(initialName);
  const [duplicate, duplicateRes] = useMutation(DUPLICATE_PRICE_LIST, {
    variables: { sourcePriceListId, name },
    onCompleted(res) {
      Alert("success", "Price List Duplicated.");
      complete(res.duplicatePriceList.priceList);
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: ["FETCH_PRICE_LISTS"],
  });

  return (
    <div className="text-base">
      <div className="flex items-center">
        <label className="pr-2">Name: </label>
        <Input
          className="w-full"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <hr />

      <div>
        <Button primary onClick={duplicate} loading={duplicateRes.loading}>
          Save
        </Button>
      </div>
    </div>
  );
};
export default DuplicatePriceListView;
